import { render } from "./Index.vue?vue&type=template&id=3bd398bd&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__